/** Backend `SimilarHtsSuggestionSource` — origin of a similar-product code suggestion (#13517). */
export enum enumSimilarHtsSuggestionSource {
  Catalog = 1,
  Chat = 2,
  ReleasedEntry = 3,
  /** A line the customs broker verified, offered before its entry is released (#13550). */
  CustomsBroker = 4,
}
